<template>
  <div class="tw-relative">
    <img
      src="../../../assets/images/gradient-rainbow-background.png"
      class="tw-pointer-events-none tw-absolute tw-z-0 tw-h-screen tw-w-full"
      alt=""
    />
    <div class="tw-relative tw-mx-auto tw-max-w-5xl tw-p-8">
      <a href="https://growthmentor.com" target="_blank">
        <img
          src="../../../assets/images/growthmentor-logo.png"
          alt="GrowthMentor logo"
          class="tw-w-40"
        />
      </a>
      <div class="tw-mt-12 tw-flex tw-flex-col lg:tw-flex-row lg:tw-space-x-16">
        <div class="tw-rounded-md tw-bg-white tw-p-8 tw-shadow-xxl lg:tw-w-1/2">
          <h1 class="tw-heading-1">Create your GrowthMentor account</h1>
          <div class="tw-mt-4">
            <AuthRegisterInvitationForm v-if="invitationToken" />
            <AuthRegisterForm v-else />
          </div>
          <div class="tw-mt-6">
            <p class="tw-text-center tw-text-sm tw-text-neutral-500">
              By signing up, you agree to our
              <a
                href="https://www.growthmentor.com/terms-of-service"
                target="_blank"
                class="tw-underline hover:tw-text-neutral-600 hover:tw-underline"
              >
                terms of use.
              </a>
            </p>
            <div class="tw-mt-8 tw-text-center tw-text-sm">
              or sign up with your social account
            </div>
          </div>
          <SocialMediaLoginButtons
            class="tw-mt-4 tw-flex tw-flex-col tw-space-y-2"
          />
          <hr class="tw-my-6" />
          <p class="tw-text-sm tw-text-neutral-500">
            Already have an account?
            <InertiaLink
              href="/users/sign_in"
              class="tw-underline hover:tw-text-neutral-600 hover:tw-underline"
            >
              Log in
            </InertiaLink>
          </p>
        </div>
        <div
          class="tw-relative tw-mt-16 tw-flex tw-flex-col tw-items-center tw-text-center lg:tw-w-1/2"
        >
          <div class="tw-absolute tw-inset-x-0">
            <QuotesIcon class="tw-mx-auto tw-w-16" />
            <blockquote class="tw-mt-16 tw-text-2xl tw-font-semibold">
              “Before GrowthMentor, I used to research problems myself, but
              always found it hard to relate learnings back to my exact
              challenge”
            </blockquote>
            <img
              src="@/assets/images/benjamin-webster.jpg"
              alt=""
              class="tw-mx-auto tw-mt-8 tw-h-12 tw-w-12 tw-rounded-full"
            />
            <div class="tw-mt-3 tw-font-bold">Benjamin Webster</div>
            <div class="tw-text-sm">Co-Founder at Troopl</div>
            <img
              src="@/assets/images/troopl-logo.png"
              alt=""
              class="tw-mx-auto tw-mt-6 tw-w-20"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SocialMediaLoginButtons from '@/modules/growthmentor/auth/components/SocialMediaLoginButtons.vue'
import QuotesIcon from '@/assets/images/icons/quotes.svg'
import AuthRegisterInvitationForm from '@/modules/growthmentor/auth/components/AuthRegisterInvitationForm.vue'
import AuthRegisterForm from '@/modules/growthmentor/auth/components/AuthRegisterForm.vue'

defineProps({
  invitationToken: {
    type: String,
    default: '',
  },
})
</script>

<script>
import AuthLayout from '@/layouts/AuthLayout.vue'

export default {
  layout: AuthLayout,
}
</script>
